export const TOKEN_NAME = 'auth-token';
export const FORCE_TOKEN_NAME = 'force-token';
